import { Component, OnInit, Input } from '@angular/core';
import { FormControl, Validators, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../../environments/environment';
import { ApplicationService } from 'app/services/application.service';
import { PopupService } from '../../../../services/shared/popup.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { PermitService } from 'app/services/permit.service';
import { VehicleService } from 'app/services/vehicle.service';
import { UtilityServiceService } from 'app/services/utility-service.service';

@Component({
  selector: 'app-app-motivation',
  templateUrl: './app-motivation.component.html',
  styleUrls: ['./app-motivation.component.css']
})
export class AppMotivationComponent implements OnInit {
  @Input() dataCntrl: any;

  form: UntypedFormGroup;
  model: any = [];
  tabload: boolean = false;
  public pageload = false;
  
  disableBtn: boolean = false;
  isProcess: boolean = true;
  public motivationSaved: boolean = false;
  isDuplicate:boolean=false;
  message: any = "";
  constructor(private formBuilder: UntypedFormBuilder, private toastr: ToastrService,
    private showModal: PopupService, public applicationService: ApplicationService,
    private router: Router, private permitService: PermitService, private vehicleService: VehicleService, private activeRoute: ActivatedRoute, public utility: UtilityServiceService) { }

  ngOnInit() {
    if (this.router.url.indexOf('view') > 0) {
      this.isProcess = false;
      this.activeRoute.params.subscribe((params: Params) => {
        this.dataCntrl.application.id = params['id'];
        if (environment.authWebApi.userData.Roles.find(p => p.Code == 'ADMIN')) {
          //this.disableBtn = true;
          //console.log('This is Admin')
        }
      });

    }
    // if(this.router.url.indexOf('change') > 0){
    //   if(this.activeRoute.params['_value'].ctrlType!=undefined && this.activeRoute.params['_value'].ctrlType=='vehicle'){
    //     this.isDuplicate=true;
    //   }
    // }
    if(this.router.url.indexOf('duplicate') > 0){
      if(this.dataCntrl.application.motivation_detail!='' && this.dataCntrl.application.motivation_detail!=null){
        this.isDuplicate=true;
      }
    }
    if (this.router.url.indexOf('edit') > 0) {
      this.activeRoute.params.subscribe((params: Params) => {
        this.dataCntrl.application.id = params['id'];
        this.dataCntrl.application.id = this.dataCntrl.application.id == null || this.dataCntrl.application.id == undefined ? this.dataCntrl.permits[0].application_id : this.dataCntrl.application.id;
        if (environment.authWebApi.userData.Roles.find(p => p.Code == 'ADMIN')) {
          this.disableBtn = true;
          //console.log('This is Admin')
        }
      });
    }
    this.initForm();
    this.model = this.dataCntrl;
    if (this.dataCntrl.status == 2) {
      this.isProcess = true;
    }
  }

  initForm() {
    this.form = this.formBuilder.group({
      motivation: ['', [<any>Validators.required]]
    });
  }

  changes() {
    this.form.statusChanges.subscribe(
      result => {
        this.dataCntrl.formValid = result == 'VALID' ? true : false
      }
    );
  }

  saveMotivation() {

    //this.tabload = true;
    if (this.dataCntrl.application.motivation_detail === null || this.dataCntrl.application.motivation_detail.length < 20) {
      return this.toastr.warning('Motivation must contain at least 20 characters');
    }
    // else if (this.router.url.indexOf('vehicle') > 0) {
    //   this.applicationService.setTab(6);
    // }
    else if (this.router.url.indexOf('duplicate') > 0 && this.router.url.indexOf('edit') < 0) {
      ////console.log("duplicated");
      ////console.log(this.dataCntrl.application);

      // this.applicationService.putApplicationDuplicate(this.dataCntrl.application)
      //   .subscribe(result => {
      //     this.pageload = false;
      //     this.dataCntrl.application = result;
      //     this.tabload = false;
      //     // this.saveDepatureDestination();
      //     this.toastr.success('Application duplicated successfully', 'Duplicate Application');
      //     let url: any = "carrier/permit/application/duplicate/edit/" + result.id;
      //     this.router.navigate([url]);
      //   },
      //     error => {
      //       this.pageload = false;
      //       this.tabload = false;
      //       this.toastr.error('Failed to save application. If the problem persist, please contact system administrator.', 'Save Application')

      //       // this.showModal.showError('Save Application','Failed to save application. If the problem persist, please contact system administrator.',error);
      //       return;
      //     });
      const nextPos = this.utility.nextTabPosition(this.utility.sequenceNumbers.motivationNum);
      this.applicationService.setTab(nextPos);
    }
    else {
      this.pageload = true;
      this.applicationService.putApplication(this.dataCntrl.application)
        .subscribe((result:any) => {
          this.pageload = false;
          this.dataCntrl.application = result;
          if (this.router.url.indexOf('view') > 0) {
            this.applicationService.motivationChanged = this.applicationService.dataControlTrackChanges.motivation_detail != result.motivation_detail;
          }
          //this.tabload = false;
          this.toastr.success('Motivation saved successfully', 'Save Application');
          const nextPos = this.utility.nextTabPosition(this.utility.sequenceNumbers.motivationNum);
          this.applicationService.setTab(nextPos);
        },
          error => {
            //console.log(error);
            this.pageload = false;
            //this.tabload = false;
            // this.showModal.showError('Save Application','Failed to save application. If the problem persist, please contact system administrator.',error);
            this.toastr.error('Failed to save application. If the problem persist, please contact system administrator.', 'Save Application')
            return;
          });
    }
  }
  backToTab() {
    if (this.router.url.indexOf('duplicate') > 0) {
      this.applicationService.setTab(2);
    } else {
      const tabNum = this.utility.tabPosition(this.utility.sequenceNumbers.motivationNum);
      //console.log("Previous Tab = ", tabNum + ' | ' + this.utility.timetableActive);
      this.applicationService.setTab(tabNum);
    }
  }
  cancelApplication() {
    let prevUrl = localStorage.getItem('previousUrl');
    if (prevUrl.search('/permit/approval') != -1) {
      this.router.navigate(['/permit/approval/']);
    } else if (prevUrl.search('/carrier/permit/application/mypermits') != -1) {
      this.router.navigate(['/carrier/permit/application/mypermits/',this.dataCntrl.carrierID]);
    } else {
      this.router.navigate(['/carrier/permit/application/',this.dataCntrl.carrierID]);
    }
  }
    // if (this.dataCntrl.application.id == undefined && this.dataCntrl.application.id == null) {
      // this.router.navigate(['/carrier/permit/application/' + this.dataCntrl.carrierID]);
    // } else {
    //   this.showModal.showConfirm('Delete Application', 'Are you sure you want to delete?', `You're about to delete application`, 'Yes', 'No')
    //     .subscribe((isConfirmed) => {
    //       if (isConfirmed) {
    //         this.deleteApplication()
    //       } else {
    //         return;
    //       }
    //     });
    // }
  // }

  deleteApplication() {
    //console.log("delete application");
    this.pageload = true;

    this.permitService.deletePermit(this.dataCntrl.permit.id).subscribe(x => {
      //console.log(x);
      this.deleteApp(this.dataCntrl.application.id);
      this.pageload = false;

      this.router.navigate(['/carrier/permit/application/' + this.dataCntrl.carrierID]);

    })
    //this.dataCntrl.application.id
    //this.dataCntrl.permit.id
  }
  deletePermit(id) {
    this.permitService.deletePermit(id).subscribe(x => {
      //console.log(x);
    })

  }
  deleteApp(id) {
    this.applicationService.deleteApplication(id).subscribe(x => {
      //console.log(x);
    })
  }
}
